import { FieldRenderProps, FieldWrapper } from '@progress/kendo-react-form'
import { Label, Error } from '@progress/kendo-react-labels'
import { Upload } from '@progress/kendo-react-upload'

import { useEffect } from 'react'

export default function ValidatedVideoUpload(
  fieldRenderProps: FieldRenderProps
) {
  const {
    value,
    id,
    optional,
    label,
    hint,
    validationMessage,
    touched,
    ...others
  } = fieldRenderProps

  const showValidationMessage: string | false | null =
    touched && validationMessage
  const showHint: boolean = !showValidationMessage && hint
  const hintId: string = showHint ? `${id}_hint` : ''
  const errorId: string = showValidationMessage ? `${id}_error` : ''
  const labelId: string = label ? `${id}_label` : ''
  const onChangeHandler = (event: any) => {
    fieldRenderProps.onChange({ value: event.newState })
  }
  const onRemoveHandler = (event: any) => {
    fieldRenderProps.onChange({ value: event.newState })
  }
  return (
    <FieldWrapper>
      <Label id={labelId} editorId={id} optional={optional}>
        {label}
      </Label>
      <Upload
        className='uploadVideo'
        id={id}
        autoUpload={false}
        showActionButtons={false}
        multiple={true}
        files={value}
        onAdd={onChangeHandler}
        onRemove={onRemoveHandler}
        ariaDescribedBy={`${hintId} ${errorId}`}
        ariaLabelledBy={labelId}
        {...others}
      />
      {showValidationMessage && <Error id={errorId}>{validationMessage}</Error>}
    </FieldWrapper>
  )
}
